import React from 'react'
import GetRequest from '../Services/APIRequest'

const CreditBalanceParisBox = () => {

  const distID = localStorage.getItem('distributorId');
  const boostID = localStorage.getItem('companyIdBooster');
  const parisID = localStorage.getItem('companyIdParis');

  const formatCurrency = (amount) => {
    // Format the absolute value
    const formatted = new Intl.NumberFormat('en-IN', {
      // style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Math.abs(amount));

    // Append "dr" if negative, "cr" if positive (or zero, adjust if needed)
    const suffix = amount < 0 ? ' dr' : ' cr';
    return formatted + suffix;
  };
  const { data } = GetRequest(`/Account/GetCurrentBalance/${distID}/${parseInt(parisID)}`);
  if (data.result !== '') {
    return (
      <div className="col-lg-3 col-6">
        <div className="small-box scol2">
          <div className="inner">
            <h3 className='indicatorBoxH3'>{formatCurrency(data.result)} <sub ></sub></h3>
            <p class="smallfontindicator">
              Paris Balance
            </p>
          </div>
          <div className="iconRightAligned">
            <i className="fa fa-inr"></i>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <> </>
    )
  }
}

export default CreditBalanceParisBox